<template>
  <v-container
    class="color-light-grey pt-3 pb-3 footer-comp"
    :class="{ 'footer-comp--bottom': bottom }"
    fluid="fluid"
  >
    <v-row v-if="$vuetify.breakpoint.mdAndUp">
      <v-col cols="12" md="2">
        <router-link to="/">
          <img
            src="../../../client-shared/img/hubbel_logo.svg"
            height="80"
            class="svg-color"
            alt="Logo von hubbel"
          />
        </router-link>
      </v-col>
      <v-col cols="6" md="3">
        <router-link to="/impressum">
          <p class="font-dark-grey font-medium">Impressum</p>
        </router-link>
        <router-link to="/nutzungsbedingungen">
          <p class="font-dark-grey font-medium">Nutzungsbedingungen</p>
        </router-link>
      </v-col>
      <v-col cols="6" md="3">
        <router-link to="/about">
          <p class="font-dark-grey font-medium">Über Uns</p>
        </router-link>
        <router-link to="/datenschutz">
          <p class="font-dark-grey font-medium">Datenschutzerklärung</p>
        </router-link>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="6" >
        <router-link to="/impressum">
          <p class="font-dark-grey font-small">Impressum</p>
        </router-link>
        <router-link to="/nutzungsbedingungen">
          <p class="font-dark-grey font-small">Nutzungsbedingungen</p>
        </router-link>
      </v-col>
      <v-col cols="6" >
        <router-link to="/about">
          <p class="font-dark-grey font-small">Über Uns</p>
        </router-link>
        <router-link to="/datenschutz">
          <p class="font-dark-grey font-small">Datenschutzerklärung</p>
        </router-link>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Footer",
  props: {
    bottom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
